<template>
  <el-breadcrumb class="bread-crumb-container" separator="/">
    <el-breadcrumb-item v-if="fistRoute" :to="{ path: fistRoute.url }">{{
      fistRoute.name
    }}</el-breadcrumb-item>
    <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
export default {
  name: "Breadcrumb",
  props: {
    show: Boolean,
    title: String,
  },
  data() {
    return {};
  },
  computed: {
    fistRoute() {
      let value = null;
      this.$store.state.routes.forEach((item) => {
        item.subList.forEach((v) => {
          if (v.url === this.$route.path) {
            value = item;
          }
        });
      });
      return value;
    },
  },

  methods: {},
  watch: {},
};
</script>

<style scoped lang="scss">
.bread-crumb-container {
    margin: 10px 0 16px;
}
</style>
